import '../../../core/components/app-root/AppRoot.css';
import './ActionsMenu.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var actionsMenuWrapper = _7a468({defaultClassName:'_1okebta2-3-8-0',variantClassNames:{size:{'default':'_1okebta3-3-8-0',condensed:'_1okebta4-3-8-0'}},defaultVariants:{size:'default'},compoundVariants:[]});
export var editorWithActionsMenu = {'default':'_1okebta5-3-8-0',condensed:'_1okebta6-3-8-0'};
export var editorWrapper = '_1okebta0-3-8-0';
export var editorWrapperFullHeight = '_1okebta1-3-8-0';